let lastScrollTop = 0;
const collectionHeader = document.querySelector('.facets-wrapper');
const collectionContainer = document.querySelector('.mobile-grid');
const DELTA = 15;

window.addEventListener("scroll", () => {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const scrollDelta = Math.abs(lastScrollTop - scrollTop);
    const headerHeight = document.querySelector('sticky-header').offsetHeight;


    if (scrollTop > lastScrollTop && scrollTop > headerHeight ) {
        // Hide header
        document.body.classList.remove('body__header--visible');
        if (collectionHeader) {
          if (scrollTop > collectionContainer.getBoundingClientRect().y + collectionHeader.getBoundingClientRect().height) {
            collectionHeader.classList.add('collection__header--hidden');
            collectionHeader.classList.remove('collection__header--sticky');
          }
        }
      } else if ((scrollTop < lastScrollTop && scrollDelta > DELTA) || scrollTop < headerHeight) {
        // Show header 
        document.body.classList.add('body__header--visible');
        if (collectionHeader) {
          collectionHeader.classList.remove('collection__header--hidden');
          if (scrollTop < headerHeight) {
            collectionHeader.classList.add('collection__header--static');
          } else {
            collectionHeader.classList.remove('collection__header--static');
          } 
        }
      }
  
      lastScrollTop = Math.max(scrollTop, 0);
}, false);